<template>
    <v-card
            class="mx-auto"
            outlined
    >
        <v-list class="best-employees pt-0" two-line>
            <v-subheader class="best-employees-header d-flex justify-center display-1 font-weight-bold">
                {{ title }}
            </v-subheader>
            <div style="border-bottom: 1px solid #333; width: 100%; height: 1px"></div>
            <template v-if="!_.isEmpty(datas)">
                <template v-for="(data, index) in datas">
                    <v-list-item class="mt-2" :key="data.id">
                        <span :class="`mr-3 caption best-employees-index index--${index + 1}`">{{ index + 1 }}</span>
                        <img 
                            class="best-employees-img mr-3"
                            v-if="_.get(data, 'user.avatar.id')" 
                            :src="_.get(data, 'user.avatar.filePath', '')" 
                            alt=""
                        >
                        <v-img v-else class="best-employees-img mr-3" src="../../../../assets/default-avatar.jpg" />
                        <v-list-item-content>
                            <v-list-item-title class="body-1 font-weight-medium mb-1">
                                {{ _.get(data, 'user.lastName', '') }} {{ _.get(data, 'user.firstName', '') }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="subtitle-1 mb-1">
                                {{ _.get(data, 'user.department.name', '') }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle :class="`caption revenue-price index--${index + 1}`">
                                <div class="d-inline-flex align-center">
                                    <v-img width="21" height="21" class="img img--cup"
                                        src="@/assets/cup.png"
                                    />
                                    <v-img width="20" height="20" class="img img--medel"
                                        src="@/assets/medel.jpg"
                                    />
                                    <span class="ml-1">{{ formatPrice(_.get(data, 'totalAmount', '')) }}</span>
                                </div>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </template>
            <template v-else>
                <common-no-result />
            </template>
        </v-list>
    </v-card>
</template>
<script>
    import { formatPrice } from '@/helpers/utils'
    export default {
        props: {
            datas: {
                type: Array,
                default: () => {}
            },
            title: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                data: {},
            }
        },
        created () {
        },
        methods: {
        }
    }
</script>
<style scoped>
    .revenue-price {
        font-weight: bold;
        color: #fb8c00 !important;
    }
    .caption .img {
        display: none;
    }
    .index--1 .img--cup {
        display: block;
    }
    .index--2 .img--medel {
        display: block;
    }
    .index--3 .img--medel {
        display: block;
    }
    .best-employees-img {
        display: inline-block; 
        max-width: 50px; 
        max-height: 50px; 
        height: 50px; 
        width: 50px;
        margin-right: 12px; 
        border-radius: 6px;
    }
</style>